import { Box, Button, ButtonGroup, Label2 } from '@sainsburys-tech/fable'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const AddNewBatchCard = () => {
  const navigate = useNavigate()

  const renderButtons = () => (
    <ButtonGroup orientation={'horizontal'}>
      <Button
        variant={'secondary'}
        style={{ backgroundColor: 'transparent' }}
        isFullWidth={false}
        layout={'col'}
        onClick={() => navigate('/hotfoodbatch')}
        testid='add-new-batch-button'
      >
        Add new batch
      </Button>
    </ButtonGroup>
  )

  return (
    <Box className='c-batch-card production-batch-card'>
      <Label2
        className='c-batch-card-title-inline'
        style={{ fontWeight: 'bold' }}
      >
        Create a batch from scratch
      </Label2>
      {renderButtons()}
    </Box>
  )
}

export default AddNewBatchCard
